var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid" }, [
    _c("div", { staticClass: "unit one-third col" }, [
      _c("div", { staticClass: "head" }, [_vm._v("\n      DataMapper\n    ")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c(
          "a",
          { attrs: { href: _vm.getLink("connectid-datamapper-resources") } },
          [_vm._v("Resources")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "unit one-third col" }, [
      _c("div", { staticClass: "head" }, [_vm._v("\n      About\n    ")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("a", { attrs: { href: _vm.getLink("connectid-datamapper") } }, [
          _vm._v("What we are all about")
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("iframe", {
      staticStyle: { display: "none", visibility: "hidden" },
      attrs: {
        src: "https://www.googletagmanager.com/ns.html?id=GTM-P5PRJXC",
        height: "0",
        width: "0"
      }
    }),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "unit one-third col" }, [
      _c("div", { staticClass: "head" }, [
        _vm._v("\n      Safe Online ApS\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "social" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.facebook.com/bysafeonline/",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "icon-facebook" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://twitter.com/BySafeOnline",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "icon-twitter" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/safe-online/",
                target: "_blank"
              }
            },
            [_c("i", { staticClass: "icon-linkedin" })]
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v("\n        Købmagergade 22, 2"),
          _c("br"),
          _vm._v("\n        1150 København K"),
          _c("br"),
          _vm._v("\n        Danmark "),
          _c("br"),
          _vm._v("\n        CVR: 38589962\n      ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: {
                href: "https://bysafeonline.com/about-safe-online/contact-us/"
              }
            },
            [_vm._v("Contact support")]
          ),
          _c("br"),
          _vm._v("\n        or call us at "),
          _c("br"),
          _vm._v(" "),
          _c("a", { attrs: { href: "tel:+4527772737" } }, [
            _vm._v("+45 2777 2737")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("noscript", [
      _c("img", {
        attrs: {
          height: "1",
          width: "1",
          src:
            "https://www.facebook.com/tr?id=170592076919016&ev=PageView&noscript=1"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12a86225", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a86225","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/comps/footer.vue
// module id = 559
// module chunks = 0